import { default as React } from 'react';
import * as yup from 'yup';
import { searchPackagingTypes } from '../../../Async/MedicationsSummaryAsync';
import { AutosaveForm, AutosaveOperations } from '../../../Components/AutosaveForm/AutosaveForm';
import { AutosaveStyledSelectAsync } from '../../../Components/AutosaveForm/AutosaveStyledSelectAsync';
import { AutosaveTextField } from '../../../Components/AutosaveForm/AutosaveTextField';
import { requiredField } from '../../../Medications.en';
import { numberInputFilter } from '../../../Shared/InputFilters';
import { referenceToKey, referenceToString } from '../../../Shared/SharedModels';
import styles from './DaaInstructionForm.module.css';
import { daaInstructionContractToForm } from './useDosageInstructionState';
var daaInstructionSchema = yup.object({
    packagingType: yup.object().nullable().required(requiredField),
    breakfast: yup.string(),
    lunch: yup.string(),
    dinner: yup.string(),
    night: yup.string(),
    additionalInstructions: yup.string()
});
export function daaInstructionFormToContract(form) {
    return {
        additionalInstructions: form.additionalInstructions,
        breakfast: isNaN(Number(form.breakfast)) ? 0 : Number(form.breakfast),
        dinner: isNaN(Number(form.dinner)) ? 0 : Number(form.dinner),
        lunch: isNaN(Number(form.lunch)) ? 0 : Number(form.lunch),
        nightTime: isNaN(Number(form.night)) ? 0 : Number(form.night),
        packagingType: form.packagingType
    };
}
export var DaaInstructionForm = function (props) {
    return (React.createElement(AutosaveForm, { initialContractValue: props.instruction, autosaveOperation: AutosaveOperations.Put, mapFormToAPIContract: daaInstructionFormToContract, mapGetContractToForm: function (contract) { return daaInstructionContractToForm(contract); }, serverCallback: props.postApi, onSubmitted: function (form) {
            props.onUpdate(form);
        }, validationSchema: daaInstructionSchema, render: function () {
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.packagingType },
                    React.createElement(AutosaveStyledSelectAsync, { readOnly: props.readOnly, maxResults: 5, field: 'packagingType', label: 'Packaging type', itemToString: referenceToString, itemToMenuKey: referenceToKey, fetch: searchPackagingTypes, isClearable: true, testId: 'daa-packaging-type', required: props.required })),
                React.createElement("div", { className: styles.breakfast },
                    React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'breakfast', label: 'Breakfast', filterFunction: numberInputFilter, maxLength: 2, placeholder: '0', helperText: ' ' })),
                React.createElement("div", { className: styles.lunch },
                    React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'lunch', label: 'Lunch', filterFunction: numberInputFilter, maxLength: 2, placeholder: '0', helperText: ' ' })),
                React.createElement("div", { className: styles.dinner },
                    React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'dinner', label: 'Dinner', filterFunction: numberInputFilter, maxLength: 2, placeholder: '0', helperText: ' ' })),
                React.createElement("div", { className: styles.night },
                    React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'night', label: 'Night', filterFunction: numberInputFilter, maxLength: 2, placeholder: '0', helperText: ' ' })),
                React.createElement("div", { className: styles.dosageInstructions },
                    React.createElement(AutosaveTextField, { readOnly: props.readOnly, field: 'additionalInstructions', label: 'Additional instructions (Optional)', multiline: true, maxLength: 250 }))));
        } }));
};
